// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/gallery/viewGalleryItem/galleryDetail.module.css
// module id = 3128
// module chunks = 0